<template>
  <div>
    <div class="tianyuanSecond">
      <div class="left_box">
        <div class="center_img">
          <img :src="left_img" class="img_cover" alt="" />
        </div>
      </div>
      <div
        class="right_box"
        :style="{ backgroundImage: 'url(' + right_backImg + ')' }"
      >
        <div class="content_box">
          <div class="title">产品介绍</div>
          <div class="_line"></div>
          <div class="en_title">{{ name }}</div>
          <div class="standard">生产标准：{{ introduce_standard }}</div>
          <div class="info">
            {{ introduce_intro }}
          </div>
        </div>
      </div>
      <div class="en_position">
        <div class="center_en_box">
          <img
            class="img_cover"
            src="../../assets/indexImg/en_img.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    obj: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      left_img: "",
      right_backImg: "",
      introduce_standard: "",
      introduce_intro: "",
      name: "",
    };
  },
  watch: {
    obj(val) {
      if (val.cate_id) {
        this.left_img = val.introduce_image;
        this.right_backImg = val.introduce_background;
        this.introduce_standard = val.introduce_standard;
        this.introduce_intro = val.introduce_intro;
        this.name = val.name;
      }
    },
  },
  computed: {
    tianYuanData() {
      return this.$store.state.tianYuanData;
    },
  },
};
</script>

<style scoped lang='scss'>
.tianyuanSecond {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  .left_box {
    width: 38%;
    height: 100%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    .center_img {
      width: 470px;
      height: 388px;
    }
  }
  .right_box {
    width: 62%;
    height: 100%;
    // background-image: url("../../assets/components_img/temporary/tianyuan_second.png");
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    .content_box {
      // width: 768px;
      width: 40vw;
      .title {
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 58px;
        color: #ffffff;
      }
      ._line {
        width: 80px;
        height: 4px;
        background: #ffffff;
      }
      .en_title {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        // line-height: 58px;
        margin-top: 4vh;
        color: #ffffff;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .standard {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin: 1vh 0 2vh 0;
      }
      .info {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 28px;
        color: #ffffff;
        letter-spacing: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 18;
      }
    }
  }
  .en_position {
    position: absolute;
    // bottom: 90px;
    bottom: 9vh;
    width: 100%;
    z-index: 99;
    .center_en_box {
      width: 59vw;
      // height: 132px;
      height: 13.2vh;
      margin-left: 13vw;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>